/* eslint-disable linebreak-style */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Button from '../elements/Button';

import { JoinUsMenu } from '../json/landingPageData';

export default function Header() {
  const [isCollapse, setIsCollapse] = useState(false);
  const [isJoinOpen, setIsJoinOpen] = useState(false);
  const location = useLocation();
  const path = location.pathname;

  const goToCareersAnchor = (sectionId) => {
    if (path !== '/careers') {
      window.location.href = `/careers#${sectionId}`;
    } else {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsJoinOpen(false);
    setIsCollapse(false);
  };

  return (
    <header className="neon-header fixed w-full top-0 z-50 bg-dark-blue bg-opacity-95 backdrop-blur-sm border-b border-blue-500 border-opacity-20">
      <div className="container mx-auto px-4 lg:px-8 py-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center cursor-pointer">
          <img
            src="/assets/images/W7logo1.png"
            alt="WEB7LABS"
            className="h-12 w-auto logo-blend transition-all duration-300"
            style={{
              filter: 'brightness(1.5) contrast(1.2)',
              mixBlendMode: 'lighten',
            }}
          />
          <span className="text-xl font-bold ml-3">
            <span className="neon-text-static">WEB</span>
            <span className="neon-number">7</span>
            <span className="neon-text-static">LABS</span>
          </span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-6">
          <Button
            className={`nav-link ${path === '/' ? 'active' : ''}`}
            type="link"
            href="/"
          >
            Home
          </Button>

          <Button
            className={`nav-link ${path === '/services' ? 'active' : ''}`}
            type="link"
            href="/services"
          >
            Services
          </Button>

          {/* Join Us — link + hover dropdown */}
          <div
            className="relative services-dropdown-container"
            onMouseEnter={() => setIsJoinOpen(true)}
            onMouseLeave={() => setIsJoinOpen(false)}
          >
            <Button
              className={`nav-link ${path === '/careers' ? 'active' : ''}`}
              type="link"
              href="/careers"
            >
              Join Us
            </Button>

            {isJoinOpen && (
              <div className="joinus-dropdown">
                <div className="joinus-dropdown-eyebrow">Explore Careers</div>
                <div className="joinus-dropdown-grid">
                  {JoinUsMenu.map((item) => (
                    <button
                      key={item.id}
                      type="button"
                      className="joinus-dropdown-link"
                      onClick={() => goToCareersAnchor(item.id)}
                    >
                      {item.name}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          <Button
            className="cta-button"
            type="link"
            href="/contact"
          >
            Let&apos;s Talk
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="block lg:hidden text-blue-400 focus:outline-none"
          onClick={() => setIsCollapse(!isCollapse)}
        >
          <svg className="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              className={`${isCollapse ? 'hidden' : 'block'}`}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
            <path
              className={`${!isCollapse ? 'hidden' : 'block'}`}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isCollapse && (
        <div className="lg:hidden mobile-menu">
          <nav className="mobile-nav">
            <Button
              className={`mobile-nav-link ${path === '/' ? 'is-active' : ''}`}
              type="link"
              href="/"
              onClick={() => setIsCollapse(false)}
            >
              Home
            </Button>

            <Button
              className={`mobile-nav-link ${path === '/services' ? 'is-active' : ''}`}
              type="link"
              href="/services"
              onClick={() => setIsCollapse(false)}
            >
              Services
            </Button>

            <Button
              className={`mobile-nav-link ${path === '/careers' ? 'is-active' : ''}`}
              type="link"
              href="/careers"
              onClick={() => setIsCollapse(false)}
            >
              Join Us
            </Button>

            <div className="mobile-submenu">
              {JoinUsMenu.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => goToCareersAnchor(item.id)}
                  className="mobile-submenu-link"
                >
                  {item.name}
                </button>
              ))}
            </div>

            <Button
              className="cta-button mobile-cta"
              type="link"
              href="/contact"
              onClick={() => setIsCollapse(false)}
            >
              Let&apos;s Talk
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
}
